(function() {
  var script = document.createElement("script");
  script.async = true;
  script.setAttribute("data-cfasync", "false");
  script.src = "//pl26352511.profitableratecpm.com/a96b05239a81b8fdd6c3c31c19786788/invoke.js";
  document.body.appendChild(script);
})();
